import { combineReducers } from '@reduxjs/toolkit'
import detail from './detail.store'
import situation from './situation.store'
import selfPhoto from './self-photo.store'
import frontDocumentPhoto from './front-document-photo.store'
import backDocumentPhoto from './back-document-photo.store'
import requiredDocuments from './required-documents.store'
import cameraResources from './camera-resources.store'

export const rootReducer = combineReducers({
  detail,
  situation,
  selfPhoto,
  frontDocumentPhoto,
  backDocumentPhoto,
  requiredDocuments,
  cameraResources,
})
